import React, {useState, useEffect} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import './routes.css';
import EditUser from './editUser';




const Admin = () => {
  const { user, isAuthenticated } = useAuth0();
  const [userList,setUserList] = useState(null);
  const [isLoaded,setIsLoaded] = useState(false);
  const [error,setError] = useState(null)



  const fetchUsers = async () => {
    
    
    await fetch("https://settersbloc.com/api/fetch_users.php",{
        method: 'POST'
    })
      .then(result => result.json())
      .then(
        (result) => {
            console.log(result)
          setUserList(result);
          setIsLoaded(true)
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setIsLoaded(true)
          setError(error)
        }
      )
          
  }
  useEffect(()=>{
    fetchUsers();
  },[]);

  const handleChildUpdate = () => {
    fetchUsers();
  };

  const categories = ['Male','Female'];


  const searchUsers = async () => {
    const input = document.getElementById(`input_users`);
    const filter = input.value.toUpperCase();
    const ul = document.getElementById(`list_users`);
    const li = ul.getElementsByTagName("li");
    console.log(li.length)
    for (var i = 0; i < li.length; i++) {
        const txtValue = li[i].textContent || li[i].innerText;
        
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                li[i].style.display = "";
            } else {
                li[i].style.display = "none";
            }
        
    }
  }

  
  if(isAuthenticated && isLoaded ){
    return (
      <div className="route_list">
        <div>
            <input type="text" id='input_users' onKeyUp={searchUsers} placeholder="Search for names, teamnames, categories.." title="Type in search criteria"></input>
        </div> 
        
        <ul id='list_users'>


       
                    {userList.map((item => (
                        
                      <li key={item.user_id}>
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <h1>
                                        
                                        {item.user_name.split('_').join(' ')}
                                        </h1>
                                        <h2>
                                           
                                            {item.team_name}
                                        </h2>
                                        <h2>
                                        {categories[item.category]}
                                        </h2>
  
                                    </td>
                                    <td>
                                    <EditUser user = {item} onUpdateParent={handleChildUpdate}/>                                          
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                      </li>
                        
                    )))}
                
            </ul>

        
      </div>
    )
  } else {
    return(
      <div>
      Loading ...
    </div>
    )
  }
};

export default Admin;